import { Button, Icon } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomAmountInput } from '@hero/components/molecules';
import { useGetProductDetail } from '@hero/services/product-service/hooks';
import { formatCurrency } from '@hero/utils';

import * as S from './style';

function DonationOptions({ charity, selectedSkus, setSelectedSkus, style }) {
  const { data: productDetail } = useGetProductDetail(charity?.merchantProductId, {
    enabled: !!charity?.merchantProductId
  });

  const productSkus = productDetail?.skus?.filter(sku => !sku?.meta?.customAmountGiftCard);
  const customAmountSku = productDetail?.skus?.find(sku => sku?.meta?.customAmountGiftCard);
  const enteredCustomAmount = selectedSkus?.find(i => i.sku === customAmountSku?.sku);
  const [customAmount, setCustomAmount] = useState(enteredCustomAmount?.price);

  useEffect(() => {
    if (!enteredCustomAmount?.meta?.customAmountGiftCard) {
      return;
    }
    setCustomAmount(enteredCustomAmount?.price);
  }, [enteredCustomAmount]);

  const { t } = useTranslation();

  const [isEditingCustomAmount, setIsEditingCustomAmount] = useState(false);

  return (
    <S.DonationWrapper>
      <S.DonationOptionsWrapper style={style}>
        {productSkus?.map(item => (
          <S.DonationOption
            key={item.code}
            variant="outlined"
            size="sm"
            color="secondary"
            onClick={() => setSelectedSkus([item])}
            active={selectedSkus?.find(i => i.sku === item.sku)}
          >
            {formatCurrency(item.price)}
          </S.DonationOption>
        ))}
      </S.DonationOptionsWrapper>
      {!!customAmount && !isEditingCustomAmount && (
        <S.CustomDonationWrapper>
          <S.DonationOption
            active={selectedSkus?.find(i => i.sku === customAmountSku?.sku)}
            variant="outlined"
            size="sm"
            color="secondary"
            onClick={() =>
              setSelectedSkus([
                {
                  ...customAmountSku,
                  priceBreakdown: {
                    ...customAmountSku.priceBreakdown,
                    display: Number(customAmount)
                  },
                  price: Number(customAmount)
                }
              ])
            }
          >
            {formatCurrency(customAmount)}
          </S.DonationOption>
          <Button
            onClick={() => {
              setIsEditingCustomAmount(true);
            }}
            startIcon={<Icon name="edit" />}
            variant="link"
            color="primary"
            emphasis="800"
          >
            {t('edit')}
          </Button>
        </S.CustomDonationWrapper>
      )}
      {!!customAmountSku && (
        <CustomAmountInput
          customAmount={customAmount}
          setCustomAmount={setCustomAmount}
          isEditingCustomAmount={isEditingCustomAmount}
          setIsEditingCustomAmount={setIsEditingCustomAmount}
          customAmountSku={customAmountSku}
          setSelectedSkus={setSelectedSkus}
          minAmount={charity?.meta?.incommMinAmount}
          maxAmount={charity?.meta?.incommMaxAmount}
        />
      )}
    </S.DonationWrapper>
  );
}

DonationOptions.propTypes = {
  charity: PropTypes.object.isRequired,
  selectedSkus: PropTypes.array.isRequired,
  setSelectedSkus: PropTypes.func.isRequired,
  style: PropTypes.object
};

export { DonationOptions };
